const Theme = {
  unit: 8,
  global: {
    background: '#F9F9F9',
    white: '#FFFFFF',
    borderColor: '#EEEDED'
  }
}

export default Theme;